import React from 'react'

import './HomeScreen.scss'

import Header from '../Header/Header'
import Aside from '../Aside/Aside'

// Logic: homescreen div is a static div that shows when app is opened. It is not interactive. Only supported action is right arrow click on remote controler and when you press it, menu with icons appears.

const HomeScreen = () => {
    // Static icons, only for homescreen
    const icons1 = [
        { id: 1, src: '/images/icon-raspored.png', text: 'TV raspored' },
        { id: 2, src: '/images/icon-videoteka.png', text: 'Videoteka' },
        { id: 3, src: '/images/icon-obitelj.png', text: 'Obitelj' }
    ]
    const icons2 = [
        { id: 4, src: '/images/icon-tv-uzivo.png', text: 'TV uživo' },
        { id: 5, src: '/images/icon-yt.png', text: 'YouTube' },
        { id: 6, src: '/images/icon-liste-programa.png', text: 'Liste programa' }
    ]
    const icons3 = [
        { id: 7, src: '/images/icon-moj-kutak.png', text: 'Moj TV kutak' },
        { id: 8, src: '/images/icon-yt-kids.png', text: 'YouTube Kids' },
        { id: 9, src: '/images/icon-vodic.png', text: 'Vodič programa' }
    ]

    return (
        <div className="body">
            <div className="main">
                <Header />
                <div className="homescreen">
                    <div className="upper-part">
                        <div className="icons-column">
                            {icons1.map(icon => (
                                <div key={icon.id} className="icon">
                                    <img src={icon.src} alt={icon.text}></img>
                                    <br />
                                    <p>{icon.text}</p>
                                </div>
                            ))}
                        </div>
                        <div className="black-screen"></div>
                        <div className="icons-column">
                            {icons2.map(icon => (
                                <div key={icon.id} className="icon">
                                    <img src={icon.src} alt={icon.text}></img>
                                    <br />
                                    <p>{icon.text}</p>
                                </div>
                            ))}
                        </div>
                        <div className="icons-column">
                            {icons3.map(icon => (
                                <div key={icon.id} className="icon">
                                    <img src={icon.src} alt={icon.text}></img>
                                    <br />
                                    <p>{icon.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="bottom">
                        <h4 className="gray-text">Gledaj Ligu prvaka - nadolazeće utakmice</h4>
                        <div className="black-boxes">
                            <div className="box"></div>
                            <div className="box"></div>
                            <div className="box"></div>
                            <div className="box"></div>
                        </div>
                    </div>
                </div>
            </div>
            <Aside rightLink="/menu" />
        </div>
    )
}

export default HomeScreen
